export default __webpack_public_path__ + "tmp_src/components/DeliveryCountdown/DeliveryCoundown.css.liquid";